const formatDayPeriodTime = (date) => {
  const formatTime = date.substring(11, 16);
  const hour = Number(formatTime.substring(0, 2));
  const dayPeriod = hour < 12 || hour === 24 ? '오전' : '오후';
  const minutes = formatTime.substring(3);
  return `${dayPeriod} ${hour === 12 ? hour : hour % 12}:${minutes}`;
};

export default formatDayPeriodTime;
